import React from 'react';
import TitleCheckSvg from '../../../../../assets/images/views/lps/angeltax_type3/title-check.svg';
import AngelTaxProjectCard from '../../questions/angelTaxProjectCard';
import { useAngelTaxProjects } from '../../questions/useAngelTaxProjects';

// エンジェル税制 LP（angeltax_type3）の「エンジェル税制対象の投資案件一覧」と、その下の CTA の帯。
// 対象案件が 0 件なら、グレーの背景のまとまり（見出しから CTA の帯まで）ごと出さない。
// 案件の取得とカードはシミュレーターのページと共通。見た目は angeltax_type3.scss の .at3-projects / .at3-cta-band が持つ

// 表示する案件の最大数。PC は 3 列 × 2 行の 6 件、SP は先頭 4 件（Figma の SP は 4 枚。シミュレーターのページの一覧と同じ）
const PREVIEW_SIZE = 6;
const SP_PREVIEW_SIZE = 4;

interface Props {
  // CTA の帯のリンク先（投資家登録）
  registrationPath: string;
}

export default function ProjectsView({ registrationPath }: Props) {
  // null は取得前
  const angelTaxProjects = useAngelTaxProjects(PREVIEW_SIZE);
  if (angelTaxProjects?.length === 0) return null;

  return (
    // グレーの背景のまとまり（見出しから CTA の帯まで）
    <div className="at3-projects-area">
      <section className="at3-projects">
        <div className="at3-section-title">
          <div className="at3-section-title__heading">
            <p className="at3-section-title__lead">
              <img
                src={TitleCheckSvg}
                alt=""
                width="28"
                height="28"
                className="at3-section-title__icon"
              />
              どんな投資先があるの？
            </p>
            <h2 className="at3-section-title__main">
              エンジェル税制対象の
              <br className="at3-sp-only" />
              投資案件一覧
            </h2>
          </div>
          <p className="at3-section-title__description">
            現在開示・募集中のエンジェル税制対象の
            <br className="at3-sp-only" />
            プロジェクトです。
          </p>
        </div>
        {/* 取得前は PC の 2 行ぶんの高さを確保して、6 件そろったときに下のセクションが押し下げられないようにする */}
        {/* 案件カードは DS の部品のため .ui-root で囲む */}
        {/* 取得中であることは aria-busy で支援技術にも伝える */}
        <ul
          className={`ui-root at3-projects__list${angelTaxProjects == null ? ' at3-projects__list--loading' : ''}`}
          aria-busy={angelTaxProjects == null}
        >
          {angelTaxProjects?.map((project, index) => (
            <li
              key={project.id}
              className={`at3-projects__item${index >= SP_PREVIEW_SIZE ? ' at3-projects__item--pc-only' : ''}`}
            >
              <AngelTaxProjectCard project={project} />
            </li>
          ))}
        </ul>
      </section>
      {/* 中身は LP のページ本体（ERB）の CTA の帯と同じ */}
      <div className="at3-cta-band">
        <div className="at3-cta-band__inner">
          <a href={registrationPath} className="at3-cta-button">
            <span className="at3-cta-button__badge">無料</span>
            <span className="at3-cta-button__label">
              <span className="at3-cta-button__main">
                投資家登録
                <span className="at3-cta-button__main-suffix">はこちら</span>
              </span>
              <span className="at3-cta-button__sub">(最短3分)</span>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
